import { Center, Spinner } from '@chakra-ui/react';
import { FlowEditor } from './FlowEditor';
import { ResourceEditorContext } from './EditorWithProviders';
import { ReactNode } from 'react';
import { sizeVars } from '@duke-hq/ui/constants/layout';
import { UnitGuideEditor } from './UnitsOfCompetency';
import { withPermission } from './withPermission';
import { useResourceByQueryId } from './hooks';
import { FileUrlsProvider } from '@duke-hq/svc-files-ui/useTiptapFileSrcResolver';

export const EditResource = withPermission('canManageCourseContent', () => {
  const resource = useResourceByQueryId();

  if (resource.isLoading) {
    return (
      <Center h={`calc(100vh - ${sizeVars.navbar})`} w="full">
        <Spinner size="xl" />
      </Center>
    );
  }

  let renderer: ReactNode = null;

  if (resource.data?.kind === 'CONVERSATION') {
    renderer = <FlowEditor data={resource.data} />;
  } else if (
    typeof resource.data === 'object' &&
    resource.data != null &&
    'kind' in resource.data &&
    resource.data['kind'] === 'PAGE' &&
    'draftVersion' in resource.data &&
    typeof resource.data.draftVersion === 'object' &&
    resource.data.draftVersion != null &&
    'content' in resource.data.draftVersion
  ) {
    renderer = (
      <UnitGuideEditor
        initialContent={resource?.data?.draftVersion?.content}
        resource={resource?.data}
      />
    );
  }

  const resourceVersionId = resource.data?.draftVersion?.id;

  if (!resource?.data?.id || !resourceVersionId) {
    throw new Error('resourceVersionId is required');
  }
  return (
    <ResourceEditorContext.Provider
      value={{
        resourceVersionId,

        resourceId: resource?.data?.id,
      }}
    >
      <FileUrlsProvider fileUrls={resource.data.fileUrls}>{renderer}</FileUrlsProvider>
    </ResourceEditorContext.Provider>
  );
});
